import PropTypes from 'prop-types'
import API from '../../../utils/http/api'
import { ACCOUNTS_ENDPOINTS } from '../../../utils/constants/endpoints';

// NOT FILES (They are just strings, Action Types)
const REQUEST = 'steppingblocks/login/REQUEST'
const SUCCESS = 'steppingblocks/login/SUCCESS'
const FAILURE = 'steppingblocks/login/FAILURE'
const SSO_CHECK_REQUEST = 'steppingblocks/ssocheck/REQUEST'
const SSO_CHECK_SUCCESS = 'steppingblocks/ssocheck/SUCCESS'
const SSO_CHECK_FAILURE = 'steppingblocks/ssocheck/FAILURE'

// Start reducer
const initialState = {
  error: null,
  requestEnded: false,
  requestStarted: false,
  universityData: null,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestEnded: false,
        requestStarted: true,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        requestStarted: true,
      }
    case FAILURE:
      return {
        ..._state,
        error: payload.error,
        requestEnded: true,
        requestStarted: true,
      }
    case SSO_CHECK_REQUEST:
      return {
        ..._state,
        error: null,
        requestEnded: false,
        requestStarted: true,
      }
    case SSO_CHECK_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        requestStarted: true,
        universityData: payload,
      }
    case SSO_CHECK_FAILURE:
      return {
        ..._state,
        error: payload.error,
        requestEnded: true,
        requestStarted: true,
      }
    default:
      return _state
  }
}

// Start Actions
export const performLogin = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.post(ACCOUNTS_ENDPOINTS.authenticateWithEmail, params)
    dispatch({ type: SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message } })
    throw new Error(error.message)
  }
}

export const checkSSOLogin = params => async dispatch => {
  dispatch({ type: SSO_CHECK_REQUEST })
  try {
    const data = await API.get(ACCOUNTS_ENDPOINTS.ssoCheck, params)
    dispatch({ type: SSO_CHECK_SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: SSO_CHECK_FAILURE, payload: { error: error.message } })
  }
}

export const performEmailLinkLogin = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.get(ACCOUNTS_ENDPOINTS.emailLinkSignon, params)
    dispatch({ type: SUCCESS })
    return data
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message } })
    throw new Error(error.message)
  }
}

// Start PropTypes
export const loginPropTypes = PropTypes.shape({
  error: PropTypes.string,
  requestEnded: PropTypes.bool.isRequired,
  requestStarted: PropTypes.bool.isRequired,
})

// @TODO Start Test Data
export const loginTestData = {
  error: null,
  requestEnded: false,
  requestStarted: false,
}



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Login/loginDuck.js